<cx1ui-footer [footerLinksApp]="footerLinksApp"></cx1ui-footer>
